import { render } from "./BeneficiaryModal.vue?vue&type=template&id=fe85f432&scoped=true"
import script from "./BeneficiaryModal.vue?vue&type=script&lang=js"
export * from "./BeneficiaryModal.vue?vue&type=script&lang=js"

import "./BeneficiaryModal.vue?vue&type=style&index=0&id=fe85f432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe85f432"]])

export default __exports__